"use client"

// This file provides country code data with flag images
export interface CountryData {
  value: string     // Country code (e.g., "+91")
  label: string     // Display label (e.g., "+91")
  country: string   // Country name (e.g., "India")
  code: string      // Country code for flag (e.g., "in")
}

// Country data sorted alphabetically by country name
export const countryList: CountryData[] = [
  { value: "+61", label: "+61", country: "Australia", code: "au" },
  { value: "+1", label: "+1", country: "Canada", code: "ca" },
  { value: "+33", label: "+33", country: "France", code: "fr" },
  { value: "+49", label: "+49", country: "Germany", code: "de" },
  { value: "+91", label: "+91", country: "India", code: "in" },
  { value: "+39", label: "+39", country: "Italy", code: "it" },
  { value: "+81", label: "+81", country: "Japan", code: "jp" },
  { value: "+52", label: "+52", country: "Mexico", code: "mx" },
  { value: "+65", label: "+65", country: "Singapore", code: "sg" },
  { value: "+27", label: "+27", country: "South Africa", code: "za" },
  { value: "+44", label: "+44", country: "United Kingdom", code: "gb" },
  { value: "+1", label: "+1", country: "United States", code: "us" }
].sort((a, b) => a.country.localeCompare(b.country));

// Country flag component that renders a flag emoji as a fallback if image fails
export const CountryFlag = ({ code, country }: { code: string, country: string }) => {
  const flagEmoji = getFlagEmoji(code);
  
  return (
    <div className="relative w-6 h-4 rounded-sm overflow-hidden flex items-center justify-center bg-gray-100">
      <img 
        src={`https://flagcdn.com/w20/${code.toLowerCase()}.png`}
        alt={country}
        className="object-cover w-full h-full"
        onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
          // If image fails to load, show flag emoji as fallback
          const imgElement = e.currentTarget as HTMLImageElement;
          imgElement.style.display = 'none';
          
          // Get the next element and set its display
          const nextElement = imgElement.nextElementSibling as HTMLElement;
          if (nextElement) {
            nextElement.style.display = 'block';
          }
        }}
      />
      <span 
        className="hidden text-xs" 
        style={{ fontFamily: "'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'" }}
      >
        {flagEmoji}
      </span>
    </div>
  );
};

// Convert country code to flag emoji
function getFlagEmoji(countryCode: string) {
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map(char => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
}
